import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { firstValueFrom } from 'rxjs';
import { ONGOING_LOGIN_SESSION_INFO } from 'src/app/pages/authentication/home/home.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { BrandService } from 'src/app/services/brand.service';
import { ContentService } from 'src/app/services/content.service';
import { AlertService } from '../../../services/alert.service';
import { LEGAL_CARDIHAB, LEGAL_QCG, LegalReference } from '../../../types/LegalReference';
import { TermsAndConditionsCmsResource } from '@cardihab/content-cache';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.page.html',
  styleUrls: ['./consent.page.scss', '../authentication.scss'],
})
export class ConsentPage implements OnInit {

  title = 'Terms and Conditions of Use';
  productName: string = "Cardihab";
  legalCardihab: LegalReference[] = LEGAL_CARDIHAB;
  legalQCG: LegalReference[] = LEGAL_QCG;
  siteCode: string = '';
  locale: string = '';
  agreedToTerms: boolean = false;
  consentHtml$: Promise<string | undefined> = Promise.resolve('');
  isFinishedLoading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private docTitle: Title,
    private alertProvider: AlertService,
    private contentService: ContentService,
    private analyticsService: AnalyticsService,
    private brandService: BrandService,
  ) {
    this.analyticsService.tagRoute('unauthenticated/consent');
    this.docTitle.setTitle(this.title);
  }

  @HostListener('document:click', ['$event'])
  clickout(_event: Event): boolean {
    const event = _event || window.event;
    const element = event.target as Element;
    if (element) {
      if ('A' === element.tagName) {
        const url = element.getAttribute('href');
        if (url) {
          Browser.open({ url });
        }
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
    }
    return true;
  }

  async ngOnInit() {
    this.route.queryParamMap.subscribe(async params => {
      this.siteCode = params.get('siteCode') || '';
      this.locale = params.get('locale') || '';
      try { SecureStoragePlugin.set({ key: ONGOING_LOGIN_SESSION_INFO, value: JSON.stringify({ page: 'consent', siteCode: this.siteCode, locale: this.locale }) }).catch(() => {}); } catch (e) {}
      if (this.locale) {
        await this.contentService.setLocale(this.locale);
      }
      const code = this.brandService.getCode();
      this.consentHtml$ = this.contentService.getContent(
        TermsAndConditionsCmsResource,
        {
          identifier: code,
        },
      ).then((res) => {
        this.isFinishedLoading = true;
        if (res.length) {
          const consent = res[0] as TermsAndConditionsCmsResource;
          return consent.content || '';
        }
        return '';
      }).catch(err => {
        this.isFinishedLoading = true;
        return '';
      });
    });
  }

  confirmConsent(): void {
    if (this.agreedToTerms) {
      this.analyticsService.tagButtonPress('consent_page', 'confirm_consent_continue');
      this.router.navigate(['unauthenticated', 'register'], {
        queryParams: { siteCode: this.siteCode, locale: this.locale }
      });
    } else {
      this.alertProvider.show(
        `Please agree to Terms and Conditions`,
        `You must agree to Terms and Conditions to continue with Registration.`
      );
    }
  }


  openLink(url: string) {
    Browser.open({ url });
  }

}
